import React from 'react';

const Avatar6 = ({ color = '#222222', size = 100 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 75 75"
    width={size}
    height={size}
  >
    {/* Outer Circle */}
    <circle
      cx="37.5"
      cy="37.5"
      r="33.26"
      stroke={color}
      strokeWidth="2"
      fill="none"
    />

    {/* Head */}
    <path
      fill={color}
      d="M37.96 33.02a8.26 8.26 0 0 0 0-16.52 8.26 8.26 0 0 0 0 16.52"
    />

    {/* Body */}
    <path
      fill={color}
      d="M38.1 54.31v-8.6c.01-.04.04-.1.08-.15l.03-.08.08-.14.07-.12.09-.15.1-.15a9.93 9.93 0 0 1 .22-.35l.04-.05a13.26 13.26 0 0 1 .5-.69l.21-.26.14-.16c.07-.1.16-.19.24-.28l.15-.16.28-.3.1-.1c.22-.22.46-.45.72-.68l.12-.1.36-.3c.07-.05.14-.1.21-.17l.38-.28.26-.18.4-.27.3-.18.43-.25a15.18 15.18 0 0 1 2.73-1.2l3.3 10.36-.28.05a.6.6 0 0 0-.08.02l-.27.06h-.06l-.37.09h-.03l-.37.09-.08.02-.9.22-.06.02-.46.12-.05.01-.52.15c-2.77.8-6.18 2.13-8.02 4.14Zm17.7 2.67v-.07l-2.4-11.73a.64.64 0 0 0-.34-.45c-.07-.03-.38-.19-.89-.4.1.74.15 1.4.15 1.96l1.95 9.55a39.91 39.91 0 0 0-6.88-2.05 13.11 13.11 0 0 0-2.91-.34c-2 0-3.59.5-4.79 1.1 2.78-2.32 8.38-3.69 10.88-4.09a.65.65 0 0 0 .52-.83l-.32-.98c.48-1.07.8-3.05-.48-7.85-1-3.78-4.2-7.05-6.29-8.86a9.32 9.32 0 0 1-12.61-.5c-2.02 1.66-5.77 5.2-6.87 9.36-1.64 6.17-.66 7.68-.07 8.6.36.54 1.36 1.06 2.34 1.18.48.07 1.38.09 2-.47.4-.37.33-1.37.23-2.63-.14-2.09-.35-4.94 1.3-8.09a.56.56 0 0 1 .76-.24c.28.15.38.5.24.77-.47.89-.77 1.76-.96 2.6h.03-.03c-.1.44-.17.89-.22 1.32 2.37-.13 4.84.32 6.66 2.12v9.6c-1.54-1.2-4.64-2.83-9.3-1.77a40 40 0 0 0-6.86 2.04l1.88-8.82c-.06-.7-.03-1.55.1-2.6l-.69.32a.65.65 0 0 0-.34.45l-2.5 11.73v.25l.04.11.03.06.04.1.03.02.02.02c.17.19.43.27.68.19.1-.04 11.29-3.66 14.87.61.13.15.3.23.5.23h4.3c.2 0 .37-.08.5-.23 3.58-4.26 14.76-.65 14.87-.61h.07c.04.02.08.02.12.02h.09c.03 0 .07 0 .1-.02.03 0 .06-.02.1-.04l.06-.03.02-.01.07-.06a.7.7 0 0 0 .08-.08l.02-.02.02-.05a.84.84 0 0 0 .06-.1l.02-.09a.5.5 0 0 0 0-.2"
    />
  </svg>
);

export default Avatar6;
